import React, { useState, useRef, useEffect } from "react";
import "../css/home.css";
import Homebanner from "../images/home-banner.jpg"
import Aboutbanner from "../images/about-home.jpg"
import { HiDevicePhoneMobile } from "react-icons/hi2";
import { TiDocumentText } from "react-icons/ti";
import { IoSettingsOutline } from "react-icons/io5";
import HomeLogin from "./login/employerLogin.jsx"
import HomeLogin2 from "./login/candidateLogin.jsx"
export default function Home() {
    const [loginsubWrap, SetloginsubWrap] = useState(false);
    const [login1, Setlogin1] = useState(false);
    const [login2, Setlogin2] = useState(false);
    const LogIn = () => {
        SetloginsubWrap(!loginsubWrap);
    }
    const employeeLogin = () => {
        Setlogin1(!login1);
    }
    const employeeLogin2 = () => {
        Setlogin2(!login2);
    }
    const closePopup = () => {
        SetloginsubWrap(false);
    };
    const popupRef = useRef(null);
    const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            closePopup();
        }
    };

    useEffect(() => {
        if (loginsubWrap) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [loginsubWrap]);

    return (
        <div className="home">
            <nav class="navbar navbar-expand-lg navbar-light fixed-top shadow-sm mainNav" >
                <div class="container px-5">
                    <a class="navbar-brand fw-bold" href="#page-top">
                        {/* <img src={Logo} alt="Logo" width="200" height="50" className="img-fluid logo" /> */}
                    </a>
                    {/* <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                        Menu
                        <i class="bi-list"></i>
                    </button> */}
                    <div class="collapse navbar-collapse" id="navbarResponsive">
                        <ul class="navbar-nav ms-auto me-4 my-3 my-lg-0">
                            <li class="nav-item"><a class="nav-link me-lg-3" href="#features">Features</a></li>
                            <li class="nav-item"><a class="nav-link me-lg-3" href="#about">About</a></li>
                        </ul>
                        <button class="btn btn-primary rounded-pill px-3 mb-2 mb-lg-0 text-uppercase" onClick={() => LogIn()}>
                            <span class="d-flex align-items-center">
                                <span class="small">Login</span>
                            </span>
                        </button>
                    </div>
                </div>
            </nav>
            {loginsubWrap &&
                <div className="login-subwrap" ref={popupRef}>
                    <div className="d-flex flex-column">
                        <div className="col-lg-12">
                            <button className="btn btn-warning btn-sm mb-2 w-100" onClick={() => employeeLogin()}>
                                Employee Login
                            </button>
                        </div>
                        <div className="col-lg-12 text-center mb-1">
                            OR
                        </div>
                        <div className="col-lg-12">
                            <button className="btn btn-primary btn-sm w-100" onClick={() => employeeLogin2()}>
                                Employer Login
                            </button>
                        </div>
                    </div>
                </div>
            }
            <header class="masthead">
                <div class="container px-5">
                    <div class="row gx-5 align-items-center">
                        <div class="col-lg-6">
                            <div class="mb-5 mb-lg-0 text-center text-lg-start">
                                <h1 class="main-head-home lh-1 mb-3">An Intuitive Recruitment Solution</h1>
                                <p class="lead fw-normal text-muted mb-5">Launch your mobile app landing page faster with this free, open source theme from Start Bootstrap!</p>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <img src={Homebanner} alt="Homebanner" className="img-fluid home-banner-img" width="600" height="600" />
                        </div>
                    </div>
                </div>
            </header>
            <aside class="text-center bg-gradient-primary-to-secondary">
                <div class="container px-5">
                    <div class="row gx-5 justify-content-center">
                        <div class="col-xl-8">
                            <div class="h2 fs-1 text-white mb-4">"An intuitive solution to a common hiring problem that we all face, wrapped up in a single platform!"</div>
                        </div>
                    </div>
                </div>
            </aside>
            <section id="features" class="bg-white">
                <div class="container px-5">
                    <div class="row gx-5 align-items-center">
                        <div className="col-lg-4">
                            <img src={Aboutbanner} alt="Aboutbanner" className="img-fluid" width="900" height="900" />
                        </div>
                        <div class="col-lg-8 mb-5 mb-lg-0">
                            <div class="container-fluid px-5">
                                <div class="row gx-5">
                                    <div class="col-md-6 mb-5">
                                        <div class="text-center">
                                            <HiDevicePhoneMobile className="mb-3" fontSize={50} color="#8521e5" />
                                            <h3 class="font-alt">Device Mockups</h3>
                                            <p class="text-muted mb-0 home-para">Ready to use HTML/CSS device mockups, no Photoshop required!</p>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-5">
                                        <div class="text-center">
                                            <TiDocumentText className="mb-3" fontSize={50} color="#8521e5" />
                                            <h3 class="font-alt">Flexible Use</h3>
                                            <p class="text-muted mb-0 home-para">Put an image, video, animation, or anything else in the screen!</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 mb-5 mb-md-0">
                                        <div class="text-center">
                                            <IoSettingsOutline className="mb-3" fontSize={50} color="#8521e5" />
                                            <h3 class="font-alt">Free to Use</h3>
                                            <p class="text-muted mb-0 home-para">As always, this theme is free to download and use for any purpose!</p>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="text-center">
                                            <HiDevicePhoneMobile className="mb-3" fontSize={50} color="#8521e5" />
                                            <h3 class="font-alt">Open Source</h3>
                                            <p class="text-muted mb-0 home-para">Since this theme is MIT licensed, you can use it commercially!</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <section class="bg-gradient-primary-to-secondary py-5" id="about">
                <div class="container px-5">
                    <h2 class="text-center text-white font-alt mb-2">Exciting opportunities await !</h2>
                    <button className="btn-explore">
                        Explore Now
                    </button>
                </div>
            </section>
            <section class="bg-white">
                <div class="container px-5">
                    <div class="row gx-5 align-items-center justify-content-center justify-content-lg-between">
                        <div class="col-12 col-lg-5">
                            <h2 class="display-4 lh-1 mb-4 sub-head-home">Enter a new age of web design</h2>
                            <p class="lead fw-normal text-muted mb-5 mb-lg-0">This section is perfect for featuring some information about your application, why it was built, the problem it solves, or anything else! There's plenty of space for text here, so don't worry about writing too much.</p>
                        </div>
                        <div class="col-sm-8 col-md-6">
                            <img src={Aboutbanner} alt="Aboutbanner" className="img-fluid" width="900" height="900" />
                        </div>
                    </div>
                </div>
            </section>
            <footer class="bg-black text-center py-4">
                <div class="container px-5">
                    <div class="text-white-50 small">
                        <div class="mb-2">&copy; Your Website 2024. All Rights Reserved.</div>
                        <a href="#!">Privacy</a>
                        <span class="mx-1">&middot;</span>
                        <a href="#!">Terms</a>

                    </div>
                </div>
            </footer>
            {login1 &&
                <div className="homelogin-wrap">
                    <HomeLogin />
                </div>
            }
            {login2 &&
                <div className="homelogin-wrap">
                    <HomeLogin2 />
                </div>
            }
        </div>
    );
}
